(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["retail-currency-selector"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ztz-currency-selector')){
    customElements.define('ztz-currency-selector',class extends HTMLElement{
      connectedCallback(){
        if(this.controller)return;
        this.controller=new AbortController();
        const options={signal:this.controller.signal};
        this.panel=this.querySelector('[data-currency-panel]');
        this.choices=this.querySelector('[data-currency-choices]');
        this.choiceButton=this.querySelector('[data-currency-select]');
        this.list=this.querySelector('[role=listbox]');
        this.select=this.querySelector('[data-currency-native]');
        this.items=[...this.querySelectorAll('[data-currency-option]')];
        this.selection=this.querySelector('[data-currency-selection]');
        this.initial=this.select.value;
        this.select.hidden=true;
        this.choices.hidden=false;
        this.choiceButton.addEventListener('click',()=>this.setChoices(this.list.hidden),options);
        this.addEventListener('click',event=>{
          const item=event.target.closest('[data-currency-option]');
          if(!item)return;
          this.select.value=item.dataset.currencyOption;
          this.sync();
          this.setChoices(false);
          this.choiceButton.focus();
        },options);
        this.panel.addEventListener('toggle',()=>{if(!this.panel.open){this.setChoices(false);this.select.value=this.initial;this.sync();}},options);
        this.addEventListener('keydown',event=>{
          if(event.key==='Escape'&&this.panel.open){
            event.preventDefault();event.stopPropagation();
            if(!this.list.hidden){this.setChoices(false);this.choiceButton.focus();}
            else{this.panel.open=false;this.panel.querySelector('summary').focus();}
            return;
          }
          const index=this.items.indexOf(event.target);
          if(index<0){if(event.target===this.choiceButton&&['ArrowDown','ArrowUp'].includes(event.key)){event.preventDefault();this.setChoices(true);}return;}
          let next=index;
          if(event.key==='ArrowDown')next=(index+1)%this.items.length;
          else if(event.key==='ArrowUp')next=(index-1+this.items.length)%this.items.length;
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=this.items.length-1;
          else return;
          event.preventDefault();this.items.forEach((item,i)=>item.tabIndex=i===next?0:-1);this.items[next].focus();
        },options);
        document.addEventListener('click',event=>{if(!this.contains(event.target))this.panel.open=false;else if(!this.choices.contains(event.target))this.setChoices(false);},options);
        this.addEventListener('focusout',event=>{if(!event.relatedTarget)return;if(!this.contains(event.relatedTarget))this.panel.open=false;else if(!this.choices.contains(event.relatedTarget))this.setChoices(false);},options);
      }
      setChoices(open){
        this.list.hidden=!open;
        this.choices.toggleAttribute('open',open);
        this.choiceButton.setAttribute('aria-expanded',String(open));
        if(open){const selected=this.items.find(item=>item.dataset.currencyOption===this.select.value);selected?.focus({preventScroll:true});selected?.scrollIntoView({block:'nearest'});}
      }
      sync(){
        this.items.forEach(item=>{
          const selected=item.dataset.currencyOption===this.select.value;
          item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;
          if(selected){this.selection.replaceChildren(...[...item.querySelector('[data-currency-option-label]').childNodes].map(node=>node.cloneNode(true)));this.choiceButton.title=item.dataset.currencyName;this.choiceButton.setAttribute('aria-label',this.choiceButton.dataset.currencyLabel+': '+this.selection.textContent.trim()+', '+item.dataset.currencyName);}
        });
      }
      disconnectedCallback(){this.controller?.abort();this.controller=null;}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
